<div class="table-responsive">
	<div class="card">
		<div class="card-body">
			<div class="d-flex align-items-center justify-content-between mt-3 mb-3" style="padding-left: 1%;">
				<h2 style="margin-bottom: 0;">Contacts</h2>
				<div class="button-items d-flex align-items-center" style="gap: 8px;">
					<button class="btn btn-primary btn-sm" (click)="loadContacts()" pTooltip="Refresh table" appActionTooltip>
						<i class="mdi mdi-reload"></i>
					</button>
					<button class="btn btn-primary btn-sm" (click)="dt.clear()" pTooltip="Clear all filters and sorting" appActionTooltip>
						Clear <i class="mdi mdi-filter-remove"></i>
					</button>
				</div>
			</div>

			<p-table [lazy]="true" #dt [columns]="cols" (onLazyLoad)="loadContacts($event)" [value]="contacts"
				dataKey="contactId" styleClass="p-datatable-contacts" [rowHover]="true" [rows]="10"
				[showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
				responsiveLayout="scroll" [paginator]="true" [autoLayout]="true" [totalRecords]="totalRecords"
				paginatorDropdownAppendTo="body" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[filterDelay]="0">
				<ng-template pTemplate="header" let-columns>
					<tr>
						<th style="width: 5rem">Actions</th>
						@for (col of columns; track col.field) {
							@if (col.field === 'associatedProjectIds') {
								<th>{{ col.header }}</th>
							} @else {
								<th [pSortableColumn]="col.field">
									<div class="flex justify-content-between align-items-center">
										<span>{{ col.header }}</span>
										<span style="display: flex; gap: 4px; align-items: center;">
											<p-sortIcon [field]="col.field"></p-sortIcon>
											<p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
												[field]="col.field" display="menu"></p-columnFilter>
										</span>
									</div>
								</th>
							}
						}
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-contact let-columns="columns">
					<tr>
						<td>
							<button type="button" class="btn btn-info btn-sm" pTooltip="View contact details" appActionTooltip
								(click)="viewContact(contact)" aria-label="View contact details">
								<i class="mdi mdi-eye"></i>
							</button>
						</td>
						@for (col of columns; track col.field) {
							<td>
								@if (col.field === 'associatedProjectIds') {
									@if (contact.associatedProjectIds && contact.associatedProjectIds.length > 0) {
										@for (projectId of contact.associatedProjectIds; track $index; let i = $index) {
											<a href="javascript:void(0)" class="text-primary" (click)="navigateToProject(projectId)"
												[pTooltip]="'View project ' + projectId" appActionTooltip>{{ projectId }}</a>
											@if (i < contact.associatedProjectIds.length - 1) {
											<span>, </span>
											}
										}
									} @else {
										-
									}
								} @else {
									{{ contact[col.field] || '-' }}
								}
							</td>
						}
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td [attr.colspan]="cols.length + 1" class="text-center py-4">No contacts found.</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>

<p-dialog [resizable]="false" [draggable]="false" [(visible)]="contactDialog" (onHide)="closeDialog()"
	[style]="{width: '70%'}" header="Contact Details" [modal]="true" styleClass="p-fluid">
	@if (selectedContact) {
		<div class="row">
			@for (detail of getContactDetails(); track detail.label) {
				<div class="col-xl-6 mb-3">
					<label class="form-label">{{ detail.label }}</label>
					<div class="form-control bg-light">{{ detail.value }}</div>
				</div>
			}
		</div>
	}
</p-dialog>
